export default "__VITE_ASSET__D_k0_d4___"